import React, { useState } from 'react'
import ApiService from "../../../../../services/ApiService"
import { notification } from "antd";
import { t } from "@lingui/core/macro"
import { Trans } from "@lingui/react/macro"

const Newsletter = (props) => {

    const { org } = props.context

    const [email, setEmail] = useState("")

    const SubmitHandler = async (e) => {
        e.preventDefault()

        if (email) {
            await ApiService.get("/mailing/subscribe/" + org.id + "/" + email)
            notification.success({
                message: t`Inscription réussie !`,
                description: t`Vous recevrez bientôt des nouvelles de notre part.`
            })
            setEmail("")
        }
    }

    return (
        <section className="wpo-news-letter-section">
            <div className="container">
                <div className="wpo-news-letter-wrap">
                    <div className="row">
                        <div className="col col-lg-10 offset-lg-1 col-md-8 offset-md-2">
                            <div className="wpo-newsletter">
                                <h3><Trans>Suivez-nous pour plus d'informations</Trans></h3>
                                <p><Trans>Restez informés sur tout nos évènements et actualités !</Trans></p>
                                <div className="wpo-newsletter-form">
                                    <form onSubmit={SubmitHandler}>
                                        <div>
                                            <input
                                                type="email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                placeholder={t`Votre Email`}
                                                className="form-control"
                                                required
                                            />
                                            <button type="submit">{t`S'inscrire`}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Newsletter;
